import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import BaseRootOption from "%/dynamic-component-editor/classes/base-root-option";

// Persists under the SAME rootOption key as the page-level tool
// ("provides-contexts") so getters and resolver work identically; only the tool differs.
export default class ComponentProvidesContexts extends BaseRootOption {
  static _optionKey = "provides-contexts";

  static userInterfaceComponent = () => {
    return {
      useCustomLabel: true,
      useVerticalOrientation: true,
      label: "Provides Contexts",
      component: inspectorTools.COMPONENT_PROVIDES_CONTEXTS,
    };
  };

  static defaultValue = {};
}
